var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVuesaxOutlineGridEdit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 22.75c-5.43 0-7.75-2.32-7.75-7.75V9c0-5.43 2.32-7.75 7.75-7.75h6c5.43 0 7.75 2.32 7.75 7.75v2c0 .41-.34.75-.75.75s-.75-.34-.75-.75V9c0-4.61-1.64-6.25-6.25-6.25H9C4.39 2.75 2.75 4.39 2.75 9v6c0 4.61 1.64 6.25 6.25 6.25h1c.41 0 .75.34.75.75s-.34.75-.75.75H9z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.031 9.25c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h19.97c.41 0 .75.34.75.75s-.34.75-.75.75H2.031zM2.031 16.25c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h9.97c.41 0 .75.34.75.75s-.34.75-.75.75h-9.97z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.76 21.99V2.02c0-.41.34-.75.75-.75s.75.34.75.75v19.97a.749.749 0 1 1-1.5 0zM14.76 11.99V2.02c0-.41.34-.75.75-.75s.75.34.75.75v9.97a.749.749 0 1 1-1.5 0z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.681 22.32c-.34-.33-.49-.82-.41-1.33l.23-1.59c.05-.38.28-.84.56-1.12l4.15-4.15c.54-.54 1.07-.82 1.63-.88.69-.07 1.38.23 2.03.88.65.65.95 1.33.88 2.03-.05.56-.34 1.09-.88 1.63l-4.15 4.15c-.27.27-.73.5-1.12.56l-1.58.23c-.09.01-.18.02-.26.02-.42 0-.8-.15-1.08-.43zm6.3-7.57c-.2.02-.44.17-.72.45l-4.15 4.15c-.05.05-.12.2-.13.27l-.23 1.59 1.63-.18c.07-.01.22-.09.27-.13l4.15-4.15c.28-.28.43-.52.45-.72.02-.23-.13-.5-.45-.82-.3-.31-.56-.46-.78-.46h-.04z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.54 18.58c-1.5-.42-2.7-1.62-3.12-3.12-.11-.4.12-.81.52-.92.41-.11.81.12.92.52.28 1 1.08 1.8 2.08 2.08a.749.749 0 0 1-.2 1.47c-.07 0-.13-.01-.2-.03z",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineGridEdit);
export default __webpack_public_path__ + "static/media/vuesax-outline-grid-edit.3b2b94295b2d9326ba5e36e73d58e215.svg";
export { ForwardRef as ReactComponent };